import { render, staticRenderFns } from "./PackagingTypesEditAdmin.vue?vue&type=template&id=7a1f21ee&scoped=true"
import script from "./PackagingTypesEditAdmin.vue?vue&type=script&lang=js"
export * from "./PackagingTypesEditAdmin.vue?vue&type=script&lang=js"
import style0 from "./PackagingTypesEditAdmin.vue?vue&type=style&index=0&id=7a1f21ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1f21ee",
  null
  
)

export default component.exports